import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { isModuleAllowed } from '../admin/accessControl';

export default function PermissionGuard({ moduleName, children }) {
  const { permissionMap, currentAdmin, isInitialized } = useAuth();

  if (!isInitialized) {
    return null;
  }

  if (isModuleAllowed(permissionMap, moduleName, Boolean(currentAdmin?.is_super_admin))) {
    return <>{children}</>;
  }

  return <Navigate to="/unauthorized" replace />;
}

PermissionGuard.propTypes = {
  children: PropTypes.node.isRequired,
  moduleName: PropTypes.string,
};

PermissionGuard.defaultProps = {
  moduleName: null,
};
